export {
  OnboardingMultipleChoiceQuestion,
  OnboardingMultipleChoiceQuestionProps,
} from './OnboardingMultipleChoiceQuestion';
